export const ml = {
	content: `
<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns:dt="uuid:C2F41010-65B3-11d1-A29F-00AA00C14882" xmlns="http://www.w3.org/TR/REC-html40">
    <head>
        <meta http-equiv=Content-Type content="text/html; charset=utf-8">
        <meta name=ProgId content=Word.Document>
        <meta name=Generator content="Microsoft Word 14">
        <meta name=Originator content="Microsoft Word 14">
        <link rel=File-List href="Finvu (CTPL)_Terms and Conditions ML(1).files/filelist.xml">
        <title>Finvu</title>
        <!--[if gte mso 9]><xml><o:DocumentProperties><o:Author>Rucha Ghude</o:Author><o:LastAuthor>Mukthyar Lukmandin</o:LastAuthor><o:Revision>1</o:Revision><o:Pages>3</o:Pages><o:Characters>26753</o:Characters><o:Lines>222</o:Lines><o:Paragraphs>62</o:Paragraphs></o:DocumentProperties><o:CustomDocumentProperties><o:KSOProductBuildVer dt:dt="string" >1033-12.2.0.20795</o:KSOProductBuildVer><o:ICV dt:dt="string" >59B5E78DF5AD4F7FA883556BF970D049_13</o:ICV></o:CustomDocumentProperties></xml><![endif]-->
        <!--[if gte mso 9]><xml><o:OfficeDocumentSettings></o:OfficeDocumentSettings></xml><![endif]-->
        <!--[if gte mso 9]><xml><w:WordDocument><w:BrowserLevel>MicrosoftInternetExplorer4</w:BrowserLevel><w:DisplayHorizontalDrawingGridEvery>0</w:DisplayHorizontalDrawingGridEvery><w:DisplayVerticalDrawingGridEvery>2</w:DisplayVerticalDrawingGridEvery><w:DocumentKind>DocumentNotSpecified</w:DocumentKind><w:DrawingGridVerticalSpacing>7.8 磅</w:DrawingGridVerticalSpacing><w:PunctuationKerning></w:PunctuationKerning><w:View>Web</w:View><w:Compatibility><w:DontGrowAutofit/><w:DoNotExpandShiftReturn/></w:Compatibility><w:Zoom>0</w:Zoom></w:WordDocument></xml><![endif]-->
        <!--[if gte mso 9]><xml><w:LatentStyles DefLockedState="false"  DefUnhideWhenUsed="true"  DefSemiHidden="true"  DefQFormat="false"  DefPriority="99"  LatentStyleCount="260" >
<w:LsdException Locked="false"  Priority="0"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Normal" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="heading 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 9" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 9" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 9" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Normal Indent" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="footnote text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="annotation text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="header" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="footer" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index heading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="35"  SemiHidden="false"  QFormat="true"  Name="caption" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="table of figures" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="envelope address" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="envelope return" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="footnote reference" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="annotation reference" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="line number" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="page number" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="endnote reference" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="endnote text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="table of authorities" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="macro" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="toa heading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="10"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Title" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Closing" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Signature" ></w:LsdException>
<w:LsdException Locked="false"  Priority="1"  SemiHidden="false"  Name="Default Paragraph Font" ></w:LsdException>
<w:LsdException Locked="false"  Priority="0"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Body Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text Indent" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Message Header" ></w:LsdException>
<w:LsdException Locked="false"  Priority="11"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Subtitle" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Salutation" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Date" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text First Indent" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text First Indent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Note Heading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text Indent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text Indent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Block Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Hyperlink" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="FollowedHyperlink" ></w:LsdException>
<w:LsdException Locked="false"  Priority="22"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Strong" ></w:LsdException>
<w:LsdException Locked="false"  Priority="20"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Emphasis" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Document Map" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Plain Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="E-mail Signature" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Normal (Web)" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Acronym" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Address" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Cite" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Code" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Definition" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Keyboard" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Preformatted" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Sample" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Typewriter" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Variable" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Normal Table" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="annotation subject" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="No List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="1 / a / i" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="1 / 1.1 / 1.1.1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Article / Section" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Simple 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Simple 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Simple 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Colorful 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Colorful 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Colorful 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table 3D effects 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table 3D effects 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table 3D effects 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Contemporary" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Elegant" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Professional" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Subtle 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Subtle 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Web 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Web 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Web 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Balloon Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Table Grid" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Theme" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Placeholder Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="No Spacing" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Paragraph" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Quote" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Intense Quote" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 6" ></w:LsdException>
</w:LatentStyles></xml><![endif]-->
        <style>
            @font-face {
                font-family: "Times New Roman";
            }

            @font-face {
                font-family: "宋体";
            }

            @font-face {
                font-family: "Courier New";
            }

            @font-face {
                font-family: "Wingdings";
            }

            @font-face {
                font-family: "Arial";
            }

            @font-face {
                font-family: "Noto Sans Malayalam";
            }

            @list l0:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l0:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l1:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l2:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l3:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l4:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l5:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l6:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level1 {
                mso-level-start-at: 3;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Times New Roman';
            }

            @list l7:level2 {
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
                mso-level-text: "%1.%2";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(22,28,45);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l7:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l8:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l9:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l10:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l11:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level1 {
                mso-level-start-at: 4;
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l12:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l13:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level1 {
                mso-level-start-at: 2;
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l14:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l15:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l16:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l17:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l18:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level1 {
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
                mso-level-text: "%1.";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(22,28,45);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l19:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l20:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l21:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l22:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l23:level2 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "%1.%2";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Times New Roman';
            }

            @list l23:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            p.MsoNormal {
                mso-style-name: Normal;
                mso-style-parent: "";
                margin: 0pt;
                margin-bottom: .0001pt;
                mso-pagination: none;
                font-family: 'Courier New';
                color: rgb(0,0,0);
                font-size: 12.0000pt;
            }

            span.10 {
                font-family: 'Courier New';
            }

            span.15 {
                font-family: Arial;
                color: rgb(22,28,45);
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 7.5000pt;
            }

            span.16 {
                font-family: 'Times New Roman';
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 10.0000pt;
            }

            span.17 {
                font-family: Arial;
                color: rgb(56,76,116);
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            span.18 {
                font-family: Arial;
                color: rgb(56,76,116);
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            p.19 {
                mso-style-name: "Heading \#1";
                margin-top: 29.0000pt;
                margin-bottom: 4.0000pt;
                mso-pagination: none;
                mso-outline-level: 1;
                font-family: Arial;
                color: rgb(22,28,45);
                font-size: 7.5000pt;
            }

            p.20 {
                mso-style-name: "Header or footer \(2\)";
                margin: 0pt;
                margin-bottom: .0001pt;
                mso-pagination: none;
                font-family: 'Times New Roman';
                color: rgb(0,0,0);
                font-size: 10.0000pt;
            }

            p.MsoBodyText {
                mso-style-name: "Body Text";
                margin-bottom: 4.0000pt;
                mso-pagination: none;
                line-height: 150%;
                font-family: Arial;
                color: rgb(56,76,116);
                font-size: 12.75pt;
            }

            p.22 {
                mso-style-name: Other;
                margin-bottom: 4.0000pt;
                mso-pagination: none;
                line-height: 150%;
                font-family: Arial;
                color: rgb(56,76,116);
                font-size: 12.75pt;
            }

            span.msoIns {
                mso-style-type: export-only;
                mso-style-name: "";
                text-decoration: underline;
                text-underline: single;
                color: blue;
            }

            span.msoDel {
                mso-style-type: export-only;
                mso-style-name: "";
                text-decoration: line-through;
                color: red;
            }

            table.MsoNormalTable {
                mso-style-name: "Table Normal";
                mso-style-parent: "";
                mso-style-noshow: yes;
                mso-tstyle-rowband-size: 0;
                mso-tstyle-colband-size: 0;
                mso-padding-alt: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;
                mso-para-margin: 0pt;
                mso-para-margin-bottom: .0001pt;
                mso-pagination: widow-orphan;
                font-family: 'Times New Roman';
                font-size: 10.0000pt;
                mso-ansi-language: #0400;
                mso-fareast-language: #0400;
                mso-bidi-language: #0400;
            }

            @page {
                mso-page-border-surround-header: no;
                mso-page-border-surround-footer: no;
            }

            @page Section0 {
                margin-top: 9.1000pt;
                margin-bottom: 21.4000pt;
                margin-left: 67.7000pt;
                margin-right: 22.1000pt;
                size: 612.0000pt 792.0000pt;
                layout-grid: 18.0000pt;
                mso-header-margin: 0.0000pt;
                mso-footer-margin: 0.1500pt;
                mso-footer: url("Finvu%20\(CTPL\)_Terms%20and%20Conditions%20ML\(1\).files/header.html") f0;
            }

            div.Section0 {
                page: Section0;
            }
        </style>
    </head>
    <body style="tab-interval:36pt;text-justify-trim:punctuation;">
        <!--StartFragment-->
        <div class="Section0" style="layout-grid:18.0000pt;">
            <p class=19 align=justify style="page-break-after:avoid;mso-pagination:lines-together;text-align:justify;
text-justify:inter-ideograph;">
                <a name="bookmark0"></a>
                <span class="15" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:22.5000pt;">സേവന നിബന്ധനകൾ</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-size:22.5000pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:15.0000pt;text-align:justify;text-justify:inter-ideograph;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">2-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ജനു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-2025-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ന് അപ്ഡേറ്റ് ചെയ്തത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:0.2000pt;margin-bottom:6.0000pt;text-indent:36.0000pt;
border-bottom:1.0000pt solid rgb(173,173,173);mso-border-bottom-alt:0.5000pt solid rgb(173,173,173);padding:0pt 0pt 1pt 0pt ;
text-align:justify;text-justify:inter-ideograph;">
                <span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                    <o:p>&nbsp;</o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-align:justify;text-justify:inter-ideograph;
line-height:140%;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകളും വ്യവസ്ഥകളും </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിബന്ധനകൾ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") Finvu </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ആപ്ലിക്കേഷനിലേക്കും വെബ്സൈറ്റിലേക്കും </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്ലാറ്റ്ഫോം</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങളിലേക്കും ഉള്ള ആക്സസ്സിനെയും അവയുടെ ഉപയോഗത്തെയും </span>
                <i style="mso-bidi-font-style:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;mso-ansi-font-style:italic;
mso-bidi-font-style:normal;font-variant:normal;font-size:12.75pt;">(</span>
                </i>
                <i>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:italic;
font-variant:normal;font-size:12.75pt;">താഴെ നിർവചിച്ചിരിക്കുന്നു</span>
                </i>
                <i style="mso-bidi-font-style:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;mso-ansi-font-style:italic;
mso-bidi-font-style:normal;font-variant:normal;font-size:12.75pt;">) </span>
                </i>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിയന്ത്രിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-align:justify;text-justify:inter-ideograph;
line-height:140%;">
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">ഈ നിബന്ധനകളിൽ </span>
                <span>
                    <a href="http://www.finvu.in/privacy">
                        <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">www.finvu.in/privacy</span>
                    </a>
                </span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">-</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">ൽ </span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">("</span>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">സ്വകാര്യതാ നയം</span>
                </b>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">") </span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">ലഭ്യമായ ഞങ്ങളുടെ സ്വകാര്യതാ നയവും ഉൾപ്പെടുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കൂടാതെ ഞങ്ങൾ കാലാകാലങ്ങളിൽ ലഭ്യമാക്കുന്നതോ പുറപ്പെടുവിക്കുന്നതോ ആയ മാർഗ്ഗനിർദ്ദേശങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കൂടുതലായ നിബന്ധനകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നയങ്ങൾ അല്ലെങ്കിൽ ബാധ്യതാ നിരാകരണങ്ങൾ എന്നിവയും ഇതിൽ ഉൾപ്പെടുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">താഴെയുള്ള വ്യവസ്ഥകൾക്ക് അനുസൃതമായി ഞങ്ങൾ ഈ നിബന്ധനകൾ ഭേദഗതി ചെയ്തേക്കാം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കാലാകാലങ്ങളിൽ ഭേദഗതി ചെയ്യുന്ന നിബന്ധനകൾ നിങ്ങൾക്ക് ബാധകമാകുകയും ചെയ്യും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകളുടെ നിലവിലെ പതിപ്പ് നിങ്ങൾക്ക് ഏതു സമയത്തും പ്ലാറ്റ്ഫോമിൽ അവലോകനം ചെയ്യാവുന്നതാണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-align:justify;text-justify:inter-ideograph;
line-height:140%;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങളുടെ ഏതൊരു ഉപയോക്താവും ഞങ്ങളുടെ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പരിസ്ഥിതി ഉപയോഗിക്കുന്ന ഏതൊരു സാമ്പത്തിക വിവര ദാതാവും അല്ലെങ്കിൽ സാമ്പത്തിക വിവര ഉപയോക്താവും </span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾ</span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ </span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ</span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">")</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;Cookiejar Technologies Private Limited</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഉം </span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">കമ്പനി</span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">", "</span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങൾ</span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">", </span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;"Finvu")</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">തമ്മിലുള്ള നിയമപരമായി ബാധകമാകുന്നതും നടപ്പിലാക്കാവുന്നതുമായ നിയമപരമായ ഒരു കരാറാണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. Cookiejar Technologies Private Limited</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ന് </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">RBI-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">യുടെ ലൈസൻസ് ഉണ്ട്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കൂടാതെ അക്കൗണ്ട് അഗ്രഗേറ്ററായി പ്രവർത്തിക്കാൻ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Reserve Bank of India (RBI) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അനുവദിച്ച രജിസ്ട്രേഷൻ സർട്ടിഫിക്കറ്റും കൈവശമുണ്ട്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. Reserve Bank of India </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ആക്ട്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, 1934-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ലെ സെക്ഷൻ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">45 IA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്രകാരം </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Reserve Bank of India </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നൽകിയ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">2020 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മാർച്ച് </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">06-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ലെ സാധുവായ ഒരു രജിസ്ട്രേഷൻ സർട്ടിഫിക്കറ്റ് കമ്പനിക്കുണ്ട്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. (a) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകൾ അംഗീകരിക്കാനും അവ പാലിക്കാനും പൂർണ്ണമായും നിയമപരമായ ശേഷിയും അധികാരവും നിങ്ങൾക്കുണ്ടെന്നും </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(b) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾ ഒരു വ്യക്തിയാണെങ്കിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾക്ക് പതിനെട്ട് വയസ്സോ അതിൽ കൂടുതലോ പ്രായമുണ്ടെന്നും നിങ്ങൾ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">18 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വയസ്സിന് താഴെയാണെങ്കിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങൾ ഉപയോഗിക്കാൻ നിങ്ങൾക്ക് മാതാപിതാക്കളിൽ ഒരാളുടെയോ നിയമപരമായ രക്ഷിതാവിന്റെയോ സഹായം ലഭിച്ചിരിക്കണമെന്നും </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(c) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾ ഒരു ഇന്ത്യൻ നിവാസിയാണെന്നും നിങ്ങൾ പ്രസ്താവിക്കുകയും ഉറപ്പുനൽകുകയും ചെയ്യുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾ ഒരു എന്റിറ്റിയെയോ സ്ഥാപനത്തെയോ മറ്റേതെങ്കിലും നിയമപരമായ വ്യക്തിയെയോ പ്രതിനിധീകരിക്കുക ആണെങ്കിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അത്തരം എന്റിറ്റിയെയോ സ്ഥാപനത്തെയോ നിയമപരമായ വ്യക്തിയെയോ ഈ നിബന്ധനകൾക്ക് വിധേയമാക്കാൻ വേണ്ട അധികാരവും അവകാശവും നിങ്ങൾക്കുണ്ടെന്ന് നിങ്ങൾ സ്ഥിരീകരിക്കുകയും ഉറപ്പു നൽകുകയും ചെയ്യുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-align:justify;text-justify:inter-ideograph;
line-height:140%;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങളുടെ പ്ലാറ്റ്ഫോം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങൾ അല്ലെങ്കിൽ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഉപയോഗിക്കുന്നതിലൂടെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾ ഈ നിബന്ധനകൾ വായിച്ചുവെന്നും മനസ്സിലാക്കിയിട്ടുണ്ടെന്നും അവയ്ക്ക് വിധേയമാണെന്നും ഇവിടെ പട്ടികപ്പെടുത്തിയിരിക്കുന്ന നിബന്ധനകൾ പാലിക്കുന്നുണ്ടെന്നും നിങ്ങൾ സമ്മതിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകളെല്ലാം നിങ്ങൾ അംഗീകരിക്കുന്നില്ലെങ്കിൽ അല്ലെങ്കിൽ ഇവിടെ പട്ടികപ്പെടുത്തിയിരിക്കുന്ന നിബന്ധനകൾ നിങ്ങൾ പാലിക്കുന്നില്ലെങ്കിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ദയവായി ഈ പ്ലാറ്റ്ഫോം ആക്സസ് ചെയ്യുകയോ സേവനങ്ങളോ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഉപയോഗിക്കുകയോ ചെയ്യരുത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 10.1000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        1.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിര്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Noto Sans Malayalam">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വചനങ്ങള്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Noto Sans Malayalam">&#8205;</font>
                </span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">മാസ്റ്റർ നിർദ്ദേശങ്ങൾ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നാൽ </span>
                <u>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">https://www.rbi.or </span>
                </u>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">g</span>
                <u>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">.in/Scripts/BS_ViewMasDirections.asDx?id= 10598</span>
                </u>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ലഭ്യമാകുന്ന കാലാകാലങ്ങളിൽ ഭേദഗതി ചെയ്തതോ പരിഷ്കരിച്ചതോ അപ്ഡേറ്റ് ചെയ്തതോ ആയ മാസ്റ്റർ നിർദ്ദേശങ്ങൾ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">- </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നോൺ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ബാങ്കിംഗ് ഫിനാൻഷ്യൽ കമ്പനി </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">- </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അക്കൗണ്ട് അഗ്രഗേറ്റർ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">റിസർവ് ബാങ്ക്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിർദ്ദേശങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, 2016 -</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നെയാണ് അർത്ഥമാക്കുന്നത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിർദ്ദേശങ്ങളുടെ ഉദ്ദേശ്യത്തിനായി </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഉപഭോക്താവ്</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നാൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങൾ നൽകുന്ന സേവനങ്ങൾ അല്ലെങ്കിൽ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മാസ്റ്റർ നിർദ്ദേശങ്ങൾ പ്രകാരം നിർവചിച്ചിരിക്കുന്ന സേവനങ്ങൾ പ്രയോജനപ്പെടുത്താനായി ഞങ്ങളുമായി ഒരു കരാറിൽ ഏർപ്പെട്ടിരിക്കുന്ന ഒരു </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">'</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വ്യക്തി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">' </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നാണ് അർത്ഥം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">സാമ്പത്തിക വിവരങ്ങൾ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നതിന് </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മാസ്റ്റർ നിർദ്ദേശങ്ങളിൽ നൽകിയിരിക്കുന്ന അതേ അർത്ഥം തന്നെയായിരിക്കും ഉള്ളത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഒരു സാമ്പത്തിക വിവര ദാതാവിന്റെ പക്കൽ ലഭ്യമായ നിങ്ങളുടെ സാമ്പത്തിക ഡാറ്റയും അതിൽ ഉൾപ്പെടുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">സാമ്പത്തിക വിവര ദാതാവ്</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നാൽ ഒരു ബാങ്ക്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ബാങ്കിംഗ് കമ്പനി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നോൺ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ബാങ്കിംഗ് ധനകാര്യ കമ്പനി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അസറ്റ് മാനേജ്മെന്റ് കമ്പനി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഡിപ്പോസിറ്ററി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഡിപ്പോസിറ്ററി പങ്കാളി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇൻഷുറൻസ് കമ്പനി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇൻഷുറൻസ് റെപ്പോസിറ്ററി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പെൻഷൻ ഫണ്ട്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മാസ്റ്റർ നിർദ്ദേശങ്ങൾ അനുസരിച്ച് </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">സാമ്പത്തിക വിവര ദാതാവ്</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ആയി പരിഗണിക്കാൻ കഴിയുന്ന അത്തരം മറ്റ് സ്ഥാപനം എന്നിവയെ അർത്ഥമാക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">സാമ്പത്തിക വിവര ഉപയോക്താവ്</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അർത്ഥമാക്കുന്നത് ഏതെങ്കിലും ധനകാര്യ മേഖല റെഗുലേറ്ററിൽ രജിസ്റ്റർ ചെയ്തിട്ടുള്ളതും അത് നിയന്ത്രിക്കുന്നതുമായ ഒരു സ്ഥാപനത്തെയോ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മാസ്റ്റർ നിർദ്ദേശങ്ങൾ അനുസരിച്ച് </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">സാമ്പത്തിക വിവര ഉപയോക്താവ്</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ആയി പരിഗണിക്കാൻ കഴിയുന്ന മറ്റ് സ്ഥാപനത്തെയോ ആണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 10.8500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഫിനാൻഷ്യൽ സെക്ടർ റെഗുലേറ്റർ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നതിന് </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മാസ്റ്റർ നിർദ്ദേശങ്ങളിൽ നൽകിയിരിക്കുന്ന അതേ അർത്ഥം ഉണ്ടായിരിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">വ്യക്തിഗത വിവരങ്ങൾ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">വ്യക്തിഗത ഡാറ്റ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നാൽ അത്തരം ഡാറ്റയിലൂടെയോ അതുമായി ബന്ധപ്പെട്ടോ ഐഡന്റിഫൈ ചെയ്യാൻ കഴിയുന്ന ഒരു വ്യക്തിയെ കുറിച്ചുള്ള ഏതെങ്കിലും ഡാറ്റ എന്നാണ് അർത്ഥം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (h)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">RBI</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നാൽ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Reserve Bank of India </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നാണ് അർത്ഥം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നത് പ്ലാറ്റ്ഫോമിൽ ലഭ്യമായ പരീക്ഷണ പരിതസ്ഥിതിയെ അർത്ഥമാക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അത് സാമ്പത്തിക വിവര ദാതാവിനെയും സാമ്പത്തിക വിവര ഉപയോക്താവിനെയും ഞങ്ങളുടെ ഓഫറുകൾ വിലയിരുത്താൻ സഹായിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-align:justify;text-justify:inter-ideograph;
line-height:140%;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിബന്ധനകൾക്കുള്ളിൽ വലിയക്ഷരത്തിൽ നൽകിയിരിക്കുന്നതും എന്നാൽ ഈ വകുപ്പ് </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">1-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ൽ നിർവചിച്ചിട്ടില്ലാത്തതുമായ വാക്കുകൾക്ക് നിർദ്ദിഷ്ട വകുപ്പിൽ നൽകിയിരിക്കുന്ന അർത്ഥമായിരിക്കും ഉണ്ടായിരിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 10.8500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        2.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വ്യാപ്തി</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">അക്കൗണ്ട് അഗ്രഗേഷൻ സേവനങ്ങൾ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">": </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്ലാറ്റ്ഫോമിലൂടെ നിങ്ങൾക്ക് ഇനിപ്പറയുന്നവ ചെയ്യാം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l9 level1 lfo4;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സാമ്പത്തിക വിവര ദാതാക്കളുടെ പക്കൽ ലഭ്യമായ സാമ്പത്തിക വിവരങ്ങൾ വീണ്ടെടുക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കാണുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഏകീകരിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സംഘടിപ്പിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പങ്കിടുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കൂടാതെ</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l9 level1 lfo4;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ സാമ്പത്തിക വിവരങ്ങൾ സാമ്പത്തിക വിവര ഉപയോക്താക്കൾക്ക് മുന്നിൽ അവതരിപ്പിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ പ്ലാറ്റ്ഫോമിലൂടെ ഞങ്ങൾ വാഗ്ദാനം ചെയ്യുന്ന അക്കൗണ്ട് അഗ്രഗേഷൻ സേവനങ്ങളെയും ഉപഭോക്താവിന് പ്ലാറ്റ്ഫോമിലേക്കുള്ള ആക്സസ് നൽകുന്നതിനെയും </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങൾ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്ന് വിളിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾക്ക് സേവനങ്ങൾ നൽകുന്നതിന് ഞങ്ങൾക്ക് ഈ നിബന്ധനകളുടെ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">6-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ാം വകുപ്പ് അനുസരിച്ച്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ സമ്മതത്തോടെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സാമ്പത്തിക വിവര ദാതാക്കളിൽ നിന്നുള്ള നിങ്ങളുടെ സാമ്പത്തിക വിവരങ്ങൾ ആക്സസ് ചെയ്യാനും നിങ്ങളുടെ ആവശ്യാനുസരണം സാമ്പത്തിക വിവര ഉപയോക്താക്കളുമായി അത് പങ്കിടാനും പരിമിതമായ അധികാരമുള്ള നിങ്ങളുടെ ഒരു ഏജന്റായി നിങ്ങൾ ഇതിനാൽ ഞങ്ങളെ അധികാരപ്പെടുത്തുകയും നിയമിക്കുകയും ചെയ്യുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 12.0500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ബാധകമായ നിയമങ്ങൾക്ക് അനുസൃതമായി സേവനങ്ങൾക്ക് നിങ്ങളിൽ നിന്ന് നിരക്ക് ഈടാക്കാനുള്ള അവകാശം ഞങ്ങളിൽ നിക്ഷിപ്തമാണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങൾക്ക് നിരക്ക് ഈടാക്കാൻ ഞങ്ങൾ ഉദ്ദേശിക്കുന്നുവെങ്കിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങളുടെ പ്ലാറ്റ്ഫോമിൽ ലഭ്യമായ വിലനിർണ്ണയ നയത്തിന് അനുസൃതമായിട്ടായിരിക്കും ഫീസ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കൂടാതെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഭാവിയിലെ ഏതു ഫീസും മുൻകാല പ്രാബല്യത്തോടെ ഈടാക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇത്തരം സാഹചര്യത്തിൽ നിങ്ങൾക്ക് രേഖാമൂലം മുൻകൂർ അറിയിപ്പ് നൽകുകയും ചെയ്യും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 10.8500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        3.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്രൊഫൈൽ സൃഷ്ടിക്കൽ</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l23 level1 lfo5;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങൾ ലഭിക്കുന്നതിന്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾ പ്ലാറ്റ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Noto Sans Malayalam">&#8204;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഫോമിൽ ഒരു പ്രൊഫൈൽ സൃഷ്ടിക്കേണ്ടതുണ്ട് </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്രൊഫൈൽ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"). </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്രൊഫൈൽ സൃഷ്ടിക്കാൻ ഒരു ഉപയോക്തൃനാമവും പാസ്വേഡും സജ്ജീകരിക്കുന്നതിനു പുറമേ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ബാധകമായ നിയമങ്ങൾ ആവശ്യപ്പെടുന്ന പ്രകാരം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾ പേര്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇമെയിൽ വിലാസം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഫോൺ നമ്പറുകൾ എന്നിവ ഉൾപ്പെടെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നാൽ അവയിൽ പരിമിതപ്പെടാത്ത</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ചില വിശദാംശങ്ങൾ കൂടി നൽകേണ്ടതുണ്ട്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ പ്രൊഫൈലുമായി ബന്ധപ്പെട്ട് നൽകിയിരിക്കുന്ന എല്ലാ വിവരങ്ങളും കൃത്യതയുള്ളതും സത്യസന്ധവുമാണെന്നും അപ്രകാരം തുടരുമെന്നും നിങ്ങൾ ഉറപ്പുനൽകുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ വിവരങ്ങളിൽ എന്തെങ്കിലും മാറ്റമോ പരിഷ്കരണമോ ഉണ്ടായാൽ പ്ലാറ്റ്ഫോമിലെ നിങ്ങളുടെ വിശദാംശങ്ങൾ നിങ്ങൾ ഉടനടി അപ്ഡേറ്റ് ചെയ്യുമെന്ന് നിങ്ങൾ സമ്മതിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l23 level1 lfo5;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഹാൻഡിലിന്റെയും ഉപയോക്തൃനാമത്തിന്റെയും പാസ്വേഡിന്റെയും സുരക്ഷയും രഹസ്യസ്വഭാവവും നിലനിർത്താനുള്ള പൂർണ്ണ ഉത്തരവാദിത്തം നിങ്ങൾക്കാണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ പ്രൊഫൈലിന്റെ ഏതെങ്കിലും വെളിപ്പെടുത്തൽ അല്ലെങ്കിൽ അനധികൃത ഉപയോഗം അല്ലെങ്കിൽ നിങ്ങളുടെ പ്രൊഫൈലുമായി ബന്ധപ്പെട്ട മറ്റേതെങ്കിലും സുരക്ഷാ ലംഘനം എന്നിവ ഞങ്ങളെ ഉടനടി അറിയിക്കാൻ നിങ്ങൾ സമ്മതിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. (i) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങളുടെ നിങ്ങൾക്ക് അറിയാവുന്നതോ സംശയിക്കുന്നതോ ആയ ഏത് അനധികൃത ഉപയോഗവും നിങ്ങൾ ഉടനടി ഞങ്ങളെ അറിയിക്കുകയും അത് തടയാൻ ന്യായമായ ശ്രമങ്ങൾ നടത്തുകയും ചെയ്യും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, (ii) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങളിലേക്ക് ആക്സസ് നേടാനോ അവ ഉപയോഗിക്കാനോ വേണ്ടി നിങ്ങൾ തെറ്റായ തിരിച്ചറിയൽ വിവരങ്ങൾ നൽകുകയുമില്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങളുടെ പ്ലാറ്റ്ഫോമിൽ നിങ്ങൾ രജിസ്റ്റർ ചെയ്യുമ്പോൾ സൃഷ്ടിക്കപ്പെടുന്ന ഒരു അതുല്യമായ ഐഡന്റിഫയറാണ് </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഹാൻഡിൽ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">", </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്ലാറ്റ്ഫോം ആക്സസ് ചെയ്യാനും സേവനങ്ങൾ നൽകാനും കക്ഷികൾ ഇത് ഉപയോഗിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l23 level1 lfo5;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ പ്രൊഫൈലിലൂടെ നടക്കുന്ന എല്ലാ പ്രവർത്തനങ്ങളുടെയും കാര്യത്തിൽ നിങ്ങൾക്ക് ബാധ്യതയും ഉത്തരവാദിത്തവും ഉണ്ടായിരിക്കുമെന്ന് നിങ്ങൾ വ്യക്തമായി സമ്മതിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ പ്രൊഫൈലിലേക്കുള്ള ഏതെങ്കിലും അനധികൃത ആക്സസിന് ഞങ്ങൾക്ക് ഒരു തരത്തിലുള്ള ബാധ്യതയുമില്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ ഉചിതമല്ലാത്ത ഉപയോഗം മൂലം നേരിട്ടോ അല്ലാതെയോ ഉണ്ടാകുന്ന ഡാറ്റയുടെയോ ഫംഗ്ഷണാലിറ്റിയുടെയോ ഏതൊരു നഷ്ടത്തിനും ഞങ്ങൾക്ക് ബാധ്യത ഉണ്ടായിരിക്കില്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-indent:7.0000pt;tab-stops:left blank 21.1500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l7 level2 lfo6;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        3.1<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l5 level1 lfo7;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങളുടെ ചില സവിശേഷതകൾ പ്രയോജനപ്പെടുത്താൻ ഉദ്ദേശിക്കുന്ന പ്ലാറ്റ്ഫോം ഉപയോക്താക്കളോടുള്ള ബന്ധത്തിൽ ചില </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ ഉപഭോക്താവിനെ അറിയുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്രക്രിയകൾ ഞങ്ങൾ ഏറ്റെടുക്കേണ്ടി വന്നേക്കാം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇക്കാര്യത്തിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കാലാകാലങ്ങളിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങളുടെ ചില സവിശേഷതകൾ ഉപയോഗിക്കാനുള്ള നിങ്ങളുടെ യോഗ്യത ഉറപ്പാക്കാൻ ആവശ്യമായ വിവരങ്ങളും രേഖകളും </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC </span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഡോക്യുമെന്റുകൾ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അപ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Noto Sans Malayalam">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ലോഡ് ചെയ്യാൻ ഞങ്ങൾ നിങ്ങളോട് ആവശ്യപ്പെടും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;margin-left:7.0000pt;tab-stops:left blank 18.8000pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l5 level1 lfo7;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">രേഖകൾ പ്രോസസ്സ് ചെയ്യാനും നിങ്ങളുടെ യോഗ്യത ഉറപ്പാക്കാനും നിങ്ങൾ ഞങ്ങളെയും ഞങ്ങൾ ഏർപ്പാടാക്കിയേക്കാവുന്ന ഏതൊരു മൂന്നാം കക്ഷി സേവന ദാതാവിനെയും അധികാരപ്പെടുത്തുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങൾ ഏറ്റെടുക്കുന്ന ഏതൊരു പ്രോസസ്സിംഗും ഞങ്ങളുടെ സ്വകാര്യതാ നയത്തിന് അനുസൃതമായിട്ടായിരിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ വകുപ്പിന് കീഴിൽ ഒരു മൂന്നാം കക്ഷി വിവരങ്ങൾ പ്രോസസ്സ് ചെയ്യുന്ന സാഹചര്യത്തിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾ കൂടുതലായ സേവന നിബന്ധനകൾക്ക് വിധേയമായേക്കാമെന്ന് നിങ്ങൾ സമ്മതിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കൂടാതെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">യോഗ്യത നിർണ്ണയിക്കാൻ കൂടുതലായ എന്തെങ്കിലും വിവരങ്ങളോ ഡാറ്റയോ ഡോക്യുമെന്റേഷനോ വേണ്ടി വന്നാൽ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മൊത്തത്തിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, "</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">അധിക വിവരങ്ങൾ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"), </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അഭ്യർത്ഥന പ്രകാരം അത്തരം അധിക വിവരങ്ങൾ ഉടനടി പങ്കിടാൻ നിങ്ങൾ ഇതിനാൽ സമ്മതിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കൂടാതെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അത്തരം അധിക വിവരങ്ങൾ പ്രോസസ്സ് ചെയ്യാൻ ഞങ്ങളെ അധികാരപ്പെടുത്തുകയും ചെയ്യുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l5 level1 lfo7;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സത്യസന്ധവും പൂർണ്ണവും കാലികവുമായ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">രേഖകളും അധിക വിവരങ്ങളും നൽകാമെന്ന് നിങ്ങൾ സമ്മതിക്കുകയും ഉറപ്പ് നൽകുകയും ചെയ്യുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. (i) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇതുമായി ബന്ധപ്പെട്ട് നൽകിയിരിക്കുന്ന ഏതെങ്കിലും തെറ്റായതോ തെറ്റിദ്ധരിപ്പിക്കുന്നതോ ആയ വിവരങ്ങൾ ഈ നിബന്ധനകളുടെ ഒരു പ്രധാന ലംഘനമാകുമെന്നും </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(ii) KYC </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">രേഖകളും അധിക വിവരങ്ങളും നൽകാൻ നിങ്ങൾ പരാജയപ്പെട്ടാൽ സേവനങ്ങളുടെ ചില സവിശേഷതകളിലേക്കുള്ള നിങ്ങളുടെ ആക്സസ് പരിമിതപ്പെടുത്തുകയോ നിരസിക്കുകയോ ചെയ്തേക്കാമെന്നും നിങ്ങൾ സമ്മതിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-indent:7.0000pt;tab-stops:left blank 21.1500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l7 level2 lfo6;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        3.2<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഡാറ്റ ഉപയോഗിക്കാനുള്ള സമ്മതം</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;margin-left:7.0000pt;tab-stops:left blank 18.8000pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ സാമ്പത്തിക വിവരങ്ങളൊന്നും ഞങ്ങൾ സംഭരിക്കുകയോ ആക്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Noto Sans Malayalam">&#8204;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സസ് ചെയ്യുകയോ കാണുകയോ ചെയ്യുന്നില്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. ReBIT (</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">റിസർവ് ബാങ്ക് ഇൻഫർമേഷൻ ടെക്നോളജി പ്രൈവറ്റ് ലിമിറ്റഡ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിർവചിച്ചിരിക്കുന്ന </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">NBFC-AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സാങ്കേതിക വിശദാംശങ്ങൾ അനുസരിച്ച്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്രൊഫൈൽ സൃഷ്ടിക്കാനും നിങ്ങളുടെ സാമ്പത്തിക അക്കൗണ്ടുകൾ കണ്ടെത്താൻ നിങ്ങളെ സഹായിക്കാനും വേണ്ടി ഞങ്ങൾ നിങ്ങളുടെ മൊബൈൽ നമ്പർ ശേഖരിക്കുകയും പരിശോധിച്ചുറപ്പാക്കുകയും ചെയ്യുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ സമ്മതവുമായി ബന്ധപ്പെട്ട പ്രവർത്തനങ്ങളെ കുറിച്ചുള്ള </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">SMS </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അറിയിപ്പുകൾ അയയ്ക്കാൻ വേണ്ടി നിങ്ങളുടെ മൊബൈൽ നമ്പർ എൻക്രിപ്റ്റ് ചെയ്ത ഒരു ഫോർമാറ്റിൽ സുരക്ഷിതമായി സൂക്ഷിച്ചിരിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കൂടാതെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഏതെങ്കിലും </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">FIP-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">യ്ക്ക് ആവശ്യമുണ്ടെങ്കിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ലിങ്ക് ചെയ്തിരിക്കുന്ന കൃത്യമായ അക്കൗണ്ടുകൾ കണ്ടെത്താൻ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">FIP-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">യെ സഹായിക്കാനായി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">PAN-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഉം ജനനത്തീയതിയും മാസ്ക്ക് ചെയ്ത രൂപത്തിൽ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(ReBIT -</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ൽ പ്രസിദ്ധീകരിച്ചിട്ടുള്ള </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">NBFC-AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സാങ്കേതിക വിശദാംശങ്ങൾ അനുസരിച്ച്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) Finvu AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സിസ്റ്റത്തിലൂടെ കൈമാറും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. PAN-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഉം ജനനത്തീയതിയും </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Finvu AA-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">യിൽ സൂക്ഷിക്കുന്നതേയില്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;margin-left:7.0000pt;tab-stops:left blank 19.0500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങളുടെ സേവനവ്യവസ്ഥ നിങ്ങളുടെ സാമ്പത്തിക വിവരങ്ങൾ വെളിപ്പെടുത്താനും കൈമാറാനുമുള്ള സമ്മതം നൽകാൻ നിങ്ങളെ പ്രാപ്തരാക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഒരു സമ്മത ആർട്ടിഫാക്റ്റ് ഉപയോഗിച്ചാണ് സമ്മതം ശേഖരിക്കുകയും സ്ഥിരീകരിക്കുകയും ചെയ്യുന്നത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇതിനായി നിങ്ങൾ ഇനിപ്പറയുന്ന ഡാറ്റാസെറ്റുകൾ സ്ഥിരീകരിക്കേണ്ടതുണ്ട്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-indent:12.0000pt;tab-stops:left blank 22.6000pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ ഐഡന്റിറ്റിയും ഓപ്ഷണൽ കോൺടാക്റ്റ് വിവരങ്ങളും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-indent:12.0000pt;tab-stops:left blank 23.5500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അഭ്യർത്ഥിച്ച സാമ്പത്തിക വിവരങ്ങളുടെ സ്വഭാവം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-indent:12.0000pt;tab-stops:left blank 24.7500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അത്തരം വിവരങ്ങൾ ശേഖരിക്കുന്നതിന്റെ ഉദ്ദേശ്യം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-indent:12.0000pt;tab-stops:left blank 212.75pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iv)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വിവരങ്ങൾ സ്വീകരിക്കുന്നവരുടെ ഐഡന്റിറ്റി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-indent:12.0000pt;tab-stops:left blank 23.3000pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (v)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വിവരങ്ങൾ ആക്സസ് ചെയ്യാനായി സമ്മത ആർട്ടിഫാക്റ്റ് ഉപയോഗിക്കുമ്പോഴെല്ലാം അറിയിപ്പ് അയയ്ക്കേണ്ട </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">URL </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ മറ്റ് വിലാസം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-indent:12.0000pt;tab-stops:left blank 24.7500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സമ്മതം സൃഷ്ടിക്കുന്ന തീയതി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സമ്മതം കാലഹരണപ്പെടുന്ന തീയതി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ ഒപ്പ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">/</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഡിജിറ്റൽ ഒപ്പ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-indent:12.0000pt;tab-stops:left blank 24.7500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ബാധകമായ നിയമത്തിനു കീഴിൽ വേണ്ടി വന്നേക്കാവുന്ന മറ്റേതെങ്കിലും വിവരങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുമായി ബന്ധപ്പെട്ട ഏതെങ്കിലും സാമ്പത്തിക വിവരങ്ങൾ നേടാനായി സമ്മത ആർട്ടിഫാക്ട് വഴി നിങ്ങൾ ഞങ്ങൾക്ക് നൽകിയ നിങ്ങളുടെ എല്ലാ സമ്മതവും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ങ്ങളും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഏതു സമയത്തും നിങ്ങൾക്ക് പിൻവലിക്കാവുന്നതാണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">റദ്ദാക്കലിനു ശേഷം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അത്തരം അറിയിപ്പിനെ സംബന്ധിച്ച് സാമ്പത്തിക വിവര ദാതാവിനെയും സാമ്പത്തിക വിവര ഉപയോക്താവിനെയും അറിയിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-indent:7.0000pt;tab-stops:left blank 18.8000pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളും പ്ലാറ്റ്ഫോമിലൂടെ വിവരങ്ങൾ ലഭിച്ച സാമ്പത്തിക വിവര ഉപയോക്താക്കളും നൽകിയ സമ്മതങ്ങളുടെ രേഖ നിങ്ങൾക്ക് എപ്പോൾ വേണമെങ്കിലും ആക്സസ് ചെയ്യാവുന്നതാണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;text-indent:7.0000pt;tab-stops:left blank 18.5500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങളുടെ സ്വകാര്യതാ നയത്തിന് അനുസൃതമായി ഞങ്ങൾക്ക് നിങ്ങളുടെ വ്യക്തിഗത വിവരങ്ങളും സാങ്കേതിക ഡാറ്റയും അനുബന്ധ വിവരങ്ങളും ശേഖരിക്കുകയും ഉപയോഗിക്കുകയും ചെയ്യാവുന്നതാണെന്ന് നിങ്ങൾ സമ്മതിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;margin-left:7.0000pt;tab-stops:left blank 17.8500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്ലാറ്റ്ഫോമിലെ സേവനങ്ങളുടെയും പ്രവർത്തനങ്ങളുടെയും ഉപയോഗവുമായി ബന്ധപ്പെട്ട സാമ്പത്തിക വിവരങ്ങളും ഡാറ്റയും ഒഴികെയുള്ള വിവരങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്ലാറ്റ്ഫോമിന്റെ ഫലപ്രാപ്തിയും കാര്യക്ഷമതയും ഇനിയും മെച്ചപ്പെടുത്താനായി വിശകലനത്തിനും ട്രെൻഡുകൾ തിരിച്ചറിയാനും സ്ഥിതിവിവരക്കണക്കുകൾക്കും വേണ്ടി ഞങ്ങൾ ഉപയോഗിച്ചേക്കാം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:140%;
mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ക്രിമിനൽ നടപടികളുമായി ബന്ധപ്പെട്ടോ മറ്റേതെങ്കിലും നടപടികളുമായി ബന്ധപ്പെട്ടോ നിങ്ങളെ സംബന്ധിച്ച ഡാറ്റ ബാധകമായ നിയമങ്ങൾക്ക് വിധേയമായി വെളിപ്പെടുത്താൻ നിയമ നിർവ്വഹണ ഏജൻസികളോ സർക്കാരോ അനുബന്ധ റെഗുലേറ്ററി സ്ഥാപനങ്ങളോ ഞങ്ങളോട് നിർദ്ദേശിച്ചേക്കാം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അത്തരം സന്ദർഭങ്ങളിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്രസക്തമായ ഏജൻസികളുമായി അല്ലെങ്കിൽ സ്ഥാപനങ്ങളുമായി അത്തരം ഡാറ്റ പങ്കിടാൻ ഞങ്ങൾക്ക് അവകാശമുണ്ടെന്ന് നിങ്ങൾ മനസ്സിലാക്കുകയും സമ്മതിക്കുകയും ചെയ്യുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 10.8500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        4.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അറിയിപ്പുകൾ</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l17 level1 lfo10;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കമ്പനി നിങ്ങളുടെ രജിസ്റ്റർ ചെയ്ത ഇമെയിൽ ഐഡിയിലോ ഫോൺ നമ്പറിലോ കാലാകാലങ്ങളിൽ അറിയിപ്പുകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ആശയവിനിമയങ്ങൾ അല്ലെങ്കിൽ അലേർട്ടുകൾ അയച്ചേക്കാമെന്നും സേവനങ്ങൾ നൽകാൻ വേണ്ട അനിവാര്യ ആശയവിനിമയങ്ങൾ നിങ്ങൾക്ക് ഒഴിവാക്കാൻ കഴിഞ്ഞേക്കില്ലെന്നും നിങ്ങൾ മനസ്സിലാക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l17 level1 lfo10;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അലേർട്ടുകളോ ആശയവിനിമയമോ സ്വീകരിക്കുന്നത് നിങ്ങൾ അപ്രാപ്തമാക്കിയിട്ടുണ്ടെങ്കിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങളുടെ ഏറ്റവും മികച്ച ഉപയോഗത്തിനായി അത് പുനഃപരിശോധിക്കാനും അലേർട്ടുകളുടെ സ്വീകരണം ശരിയായ വിധത്തിൽ സജീവമാക്കാനും കമ്പനി ശുപാർശ ചെയ്യുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l17 level1 lfo10;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കമ്പനിയിൽ നിന്നുള്ള ആശയവിനിമയങ്ങൾ കർശനമായും സേവനങ്ങളുമായി മാത്രം ബന്ധപ്പെട്ടതായിരിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        5.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങളുടെ ബാധ്യതകൾ</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ വ്യക്തമായ സമ്മതത്തിന്റെ അടിസ്ഥാനത്തിൽ ഞങ്ങൾ നിങ്ങൾക്ക് സേവനങ്ങൾ നൽകേണ്ടതാണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾക്ക് സേവനങ്ങൾ നൽകാനുള്ള ക്രമീകരണത്തിന്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങളും നിങ്ങളും സാമ്പത്തിക വിവരങ്ങളുടെ ഉപയോക്താക്കളും തമ്മിലുള്ള ഉചിതമായ കരാറുകളുടെയും കൂടാതെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">/</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ അംഗീകാരങ്ങളുടെയും പിന്തുണയുണ്ടെന്ന് ഞങ്ങൾ ഉറപ്പാക്കേണ്ടതാണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുമായി ബന്ധപ്പെട്ടതും സേവനങ്ങളുമായി ബന്ധപ്പെട്ട് ഞങ്ങൾ പ്രോസസ്സ് ചെയ്തേക്കാവുന്നതും ആയ ഒരു സാമ്പത്തിക വിവരവും ഞങ്ങൾ സംഭരിക്കുന്നില്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അക്കൗണ്ട് അഗ്രഗേഷൻ ബിസിനസ്സ് ഏറ്റെടുക്കാനായി ഞങ്ങൾ ഒരു മൂന്നാം കക്ഷി സേവന ദാതാവിന്റെ സേവനങ്ങൾ ഉപയോഗിക്കില്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വിവിധ സാമ്പത്തിക വിവര ദാതാക്കളുമായുള്ള അക്കൗണ്ടുകളോടു ബന്ധപ്പെട്ട നിങ്ങളുടെ ഉപയോക്തൃ ഒതന്റിക്കേഷൻ ക്രെഡൻഷ്യലുകൾ ഞങ്ങൾ ആക്സസ് ചെയ്യില്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        6.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ ഉത്തരവാദിത്തങ്ങൾ</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l0 level1 lfo12;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങളിലൂടെയോ സേവനങ്ങളുമായി ബന്ധപ്പെട്ടോ നൽകുന്ന എല്ലാ വിവരങ്ങളും ഈ നിബന്ധനകൾ അംഗീകരിക്കുന്ന തീയതിയിൽ പൂർണ്ണവും സത്യവും കൃത്യവുമാണെന്നും നിങ്ങൾ സേവനങ്ങൾ പ്രയോജനപ്പെടുത്തുന്ന കാലയളവിൽ അവ പൂർണ്ണവും സത്യവും കൃത്യവുമായി തുടരുമെന്നും നിങ്ങൾ പ്രസ്താവിക്കുകയും ഉറപ്പ് നൽകുകയും ചെയ്യുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകൾ നിലവിലുള്ള കാലയളവിൽ നിങ്ങൾ നൽകുന്ന ഏതെങ്കിലും വിവരങ്ങളിൽ മാറ്റം വന്നാൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അത്തരം മാറ്റങ്ങൾ ഉടനടി ഞങ്ങളുടെ ശ്രദ്ധയിൽപ്പെടുത്താനും നിങ്ങളുടെ പ്രൊഫൈലിലൂടെ അത് ഉടനടി അപ്ഡേറ്റ് ചെയ്യാനുമുള്ള ഉത്തരവാദിത്വം നിങ്ങൾ ഏറ്റെടുക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്ലാറ്റ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Noto Sans Malayalam">&#8204;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഫോമിലൂടെ നിങ്ങൾ കൈമാറുന്ന വിവരങ്ങളുടെ ഉള്ളടക്കത്തിൽ ഞങ്ങൾക്ക് യാതൊരു നിയന്ത്രണവുമില്ലെന്ന് നിങ്ങൾ സമ്മതിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങൾ ലഭ്യമാക്കാനായി നൽകിയിട്ടുള്ള ഏതെങ്കിലും വിവരങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">രേഖകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മെറ്റീരിയൽ അല്ലെങ്കിൽ ഡാറ്റ തെറ്റോ അപൂർണ്ണമോ കൃത്യതയില്ലാത്തതോ തെറ്റിദ്ധരിപ്പിക്കുന്നതോ ആണെങ്കിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ നിങ്ങൾ ഏതെങ്കിലും വസ്തുത വെളിപ്പെടുത്താൻ പരാജയപ്പെട്ടാൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾക്ക് ഉണ്ടായേക്കാവുന്ന ഏതെങ്കിലും നഷ്ടത്തിനോ കോട്ടത്തിനോ ഞങ്ങൾക്ക് ഉത്തരവാദിത്തമോ ബാധ്യതയോ ഉണ്ടായിരിക്കുന്നതല്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l0 level1 lfo12;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ബാധകമായ നിയമങ്ങൾ പാലിക്കുന്നുണ്ടെന്ന് ഉറപ്പാക്കാനുള്ള പൂർണമായ ഉത്തരവാദിത്തം നിങ്ങൾക്കായിരിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കൂടാതെ ഈ കാര്യത്തിലെ നിങ്ങളുടെ ഉത്തരവാദിത്വങ്ങളുടെ ലംഘനം മൂലം ഉണ്ടാകാവുന്ന ഏതൊരു ബാധ്യതയ്ക്കും നിങ്ങൾ മാത്രമായിരിക്കും ഉത്തരവാദി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l0 level1 lfo12;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകൾക്ക് കീഴിലുള്ള നിങ്ങളുടെ ബാധ്യതകളോ ഉടമ്പടികളോ ലംഘിച്ചതിന്റെ ഫലമായി ഞങ്ങൾക്ക് എതിരെ ആരംഭിച്ചേക്കാവുന്ന ഏതൊരു നടപടിക്രമത്തിന്റെയും പ്രതിരോധത്തിൽ നിങ്ങൾ ഞങ്ങൾക്ക് എല്ലാ സഹകരണവും നൽകും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 10.8500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        7.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിരോധിത പ്രവർത്തനങ്ങൾ</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l13 level1 lfo13;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകളിൽ വ്യക്തമായി അനുവദിച്ചിട്ടുള്ള രീതിയിൽ അല്ലാതെ മറ്റൊരു തരത്തിലും നിങ്ങൾ ഈ സേവനങ്ങൾ ഉപയോഗിക്കരുത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മുൻ വാചകത്തിന്റെ പൊതുവായ സ്വഭാവം പരിമിതപ്പെടുത്താതെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾ ഇനിപ്പറയുന്നവ ചെയ്യരുത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്ലാറ്റ്ഫോം പകർത്തുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പരിഷ്ക്കരിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പൊരുത്തപ്പെടുത്തുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വിവർത്തനം ചെയ്യുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">റിവേഴ്സ് എഞ്ചിനീയറിംഗ് നടത്തുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഡീകംപൈൽ ചെയ്യുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഡിസ്അസംബിൾ ചെയ്യുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മാറ്റം വരുത്തുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പുനർനിർമ്മിക്കുക അല്ലെങ്കിൽ മറ്റേതെങ്കിലും രീതിയിൽ അതിൽ മാറ്റങ്ങൾ വരുത്തുക അല്ലെങ്കിൽ ഏതെങ്കിലും ഡെറിവേറ്റീവ് വർക്കുകൾ സൃഷ്ടിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മൂന്നാം കക്ഷികൾക്ക് സമയം പങ്കിടൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ബെഞ്ച്മാർക്കിംഗ് അല്ലെങ്കിൽ മറ്റ് കമ്പ്യൂട്ടർ സേവനങ്ങൾ നൽകാനായി ഏതെങ്കിലും വിധത്തിൽ പ്ലാറ്റ്ഫോം ഉപയോഗിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇവിടെ വ്യക്തമായി പ്രതിപാദിച്ചിരിക്കുന്നത് അല്ലാതെ പ്ലാറ്റ്ഫോമിന്റെ പ്രവർത്തനക്ഷമത ആക്സസ് ചെയ്യാനോ പ്രയോജനപ്പെടുത്താനോ ഏതെങ്കിലും മൂന്നാം കക്ഷിയെ അനുവദിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ മത്സരിക്കുന്നതോ സമാനമായതോ ആയ ഏതെങ്കിലും ഉൽപ്പന്നം വികസിപ്പിക്കാനായി പ്ലാറ്റ്ഫോം ഉപയോഗിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 13.0000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വൈറസുകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ട്രോജൻ ഹോഴ്സുകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വേമുകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ടൈംബോംബുകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കീസ്ട്രോക്ക് ലോഗറുകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സ്പൈവെയർ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ആഡ്വെയർ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ മറ്റേതെങ്കിലും ദോഷകരമായ പ്രോഗ്രാമുകൾ അല്ലെങ്കിൽ ഏതെങ്കിലും കമ്പ്യൂട്ടർ സോഫ്റ്റ്വെയറിന്റെയോ ഹാർഡ്വെയറിന്റെയോ പ്രവർത്തനത്തെ പ്രതികൂലമായി ബാധിക്കാനോ ഏതെങ്കിലും കമ്പ്യൂട്ടർ റിസോഴ്സിന്റെ പ്രവർത്തനക്ഷമത നശിപ്പിക്കാനോ പരിമിതപ്പെടുത്താനോ രൂപകൽപ്പന ചെയ്തിരിക്കുന്ന സമാനമായ കമ്പ്യൂട്ടർ കോഡ് അടങ്ങിയിരിക്കുന്ന ഏതെങ്കിലും ഡാറ്റ കൈമാറാനോ അയയ്ക്കാനോ അപ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Noto Sans Malayalam">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ലോഡ് ചെയ്യാനോ വേണ്ടി സേവനങ്ങൾ ഉപയോഗിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 12.5000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iv)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്ലാറ്റ്ഫോമോ അതിന്റെ ഏതെങ്കിലും ഭാഗമോ നിരീക്ഷിക്കാനോ പകർത്താനോ വേണ്ടി ഏതെങ്കിലും റോബോട്ട്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സ്പൈഡർ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മറ്റ് ഓട്ടോമേറ്റഡ് ഡിവൈസ് അല്ലെങ്കിൽ മാനുവൽ പ്രക്രിയ ഉപയോഗിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (v)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഏതെങ്കിലും പേറ്റന്റ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വ്യാപാരമുദ്ര</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പകർപ്പവകാശം അല്ലെങ്കിൽ മറ്റ് ഉടമസ്ഥാവകാശങ്ങൾ ലംഘിക്കുക</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 13.0000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വ്യക്തികൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഉദ്യോഗസ്ഥർ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഡയറക്ടർമാർ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ജീവനക്കാർ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഏജന്റുമാർ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അംഗീകൃത പ്രതിനിധികൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഫോറം നേതാക്കൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഗൈഡുകൾ അല്ലെങ്കിൽ ഹോസ്റ്റുകൾ എന്നിവർ ഉൾപ്പെടെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നാൽ അവരിൽ മാത്രം പരിമിതപ്പെടാത്ത</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഏതെങ്കിലും വ്യക്തിയെയോ സ്ഥാപനത്തെയോ അനുകരിക്കുകയോ തെറ്റായി പ്രതിനിധീകരിക്കുകയോ ചെയ്യുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ ഏതെങ്കിലും വിവരങ്ങളോ അക്കൗണ്ടുകളോ തെറ്റായി പ്രസ്താവിക്കുകയോ മറ്റുവിധത്തിൽ തെറ്റായി പ്രതിനിധീകരിക്കുകയോ ചെയ്യുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 13.9500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സന്ദേശത്തിന്റെ ഉത്ഭവം സംബന്ധിച്ച് വിലാസക്കാരനെ വഞ്ചിക്കുകയോ തെറ്റിദ്ധരിപ്പിക്കുകയോ ചെയ്യുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ കേന്ദ്ര സർക്കാരിന്റെ വസ്തുതാ പരിശോധന യൂണിറ്റ് ഔദ്യോഗിക ഗസറ്റിൽ പ്രസിദ്ധീകരിച്ച വിജ്ഞാപനത്തിലൂടെ മന്ത്രാലയം വ്യക്തമാക്കുന്ന കേന്ദ്ര സർക്കാരിന്റെ ഏതെങ്കിലും ബിസിനസ്സുമായി ബന്ധപ്പെട്ട് വ്യാജമോ തെറ്റോ തെറ്റിദ്ധരിപ്പിക്കുന്നതോ ആയ ഏതെങ്കിലും തെറ്റായവിവരങ്ങളോ വിവരങ്ങളോ അറിഞ്ഞുകൊണ്ട് മനഃപൂർവ്വം കൈമാറുന്നത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 15.1500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (viii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇന്ത്യയുടെ ഐക്യം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അഖണ്ഡത</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്രതിരോധം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സുരക്ഷ അല്ലെങ്കിൽ പരമാധികാരം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വിദേശ രാജ്യങ്ങളുമായുള്ള സൗഹൃദബന്ധം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പൊതു ക്രമം എന്നിവയ്ക്ക് ഭീഷണി ഉയർത്തുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ ഏതെങ്കിലും കുറ്റകൃത്യം ചെയ്യാൻ പ്രേരിപ്പിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ ഏതെങ്കിലും കുറ്റകൃത്യത്തിന്റെ അന്വേഷണം തടയുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ മറ്റ് രാജ്യത്തെ അപമാനിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 12.7500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ix)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മറ്റൊരാളായി നടിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (x)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സോഫ്റ്റ്വെയർ വൈറസ് അല്ലെങ്കിൽ തടസ്സം സൃഷ്ടിക്കാനായി രൂപകൽപ്പന ചെയ്തിട്ടുള്ള മറ്റേതെങ്കിലും കമ്പ്യൂട്ടർ കോഡ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഫയൽ അല്ലെങ്കിൽ പ്രോഗ്രാം അടങ്ങിയിരിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 12.7500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (xi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നേരിട്ടോ പരോഷമായോ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഒരു ശേഖരണം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സമാഹാരണം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഡാറ്റാബേസ് അല്ലെങ്കിൽ ഡയറക്ടറി സൃഷ്ടിക്കുകയോ സമാഹരിക്കുകയോ ചെയ്യാൻ പ്ലാറ്റ്ഫോമിൽ നിന്ന് വ്യവസ്ഥാപിതമായി ഉള്ളടക്കം വീണ്ടെടുക്കുന്നതിൽ ഏർപ്പെടുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 13.9500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (xii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങൾ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(A) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിയമവിരുദ്ധമായ രീതിയിൽ ഉപയോഗിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, (B) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വഞ്ചനാപരമോ ദ്രോഹപരമോ ആയ പ്രവർത്തനങ്ങൾക്ക് ഉപയോഗിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(C) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകൾക്ക് വിരുദ്ധമായ ഏതെങ്കിലും വിധത്തിൽ ഉപയോഗിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 15.1500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (xiii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ബാധകമായ നിയമങ്ങൾ ഏതെങ്കിലും രീതിയിൽ ലംഘിക്കുക</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l12 level1 lfo15;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്ലാറ്റ്ഫോമിലേക്കുള്ള ആക്സസിനെ തടസ്സപ്പെടുത്തുന്നതോ ശല്യപ്പെടുത്തുന്നതോ ആയ ഒരു പ്രവർത്തനത്തിലും ഏർപ്പെടില്ലെന്ന് നിങ്ങൾ ഉറപ്പ് തരുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l12 level1 lfo15;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഹാക്കിംഗിലൂടെയോ പാസ്വേഡ് മൈനിംഗിലൂടെയോ മറ്റേതെങ്കിലും നിയമവിരുദ്ധമായ മാർഗങ്ങളിലൂടെയോ പ്ലാറ്റ്ഫോമിലെ ഏതെങ്കിലും ഭാഗത്തേക്കോ സവിശേഷതയിലേക്കോ പ്ലാറ്റ്ഫോമുമായി ബന്ധിപ്പിച്ചിരിക്കുന്ന മറ്റേതെങ്കിലും സിസ്റ്റങ്ങളിലേക്കോ നെറ്റ്വർക്കുകളിലേക്കോ ഞങ്ങളുടെ സെർവറുകളിലേക്കോ അല്ലെങ്കിൽ പ്ലാറ്റ്ഫോം വഴിയോ അനധികൃത ആക്സസ് നേടാൻ നിങ്ങൾ ശ്രമിക്കരുത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        8.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ബൗദ്ധിക സ്വത്ത്</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l11 level1 lfo16;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്ലാറ്റ്ഫോമിൽ നിന്നും സേവനങ്ങളിൽ നിന്നും സാൻഡ്ബോക്സിൽ നിന്നും ഉണ്ടാകുന്ന എല്ലാ ബൗദ്ധിക സ്വത്തവകാശങ്ങളും ഉൾപ്പെടെ പ്ലാറ്റ്ഫോമിലും സേവനങ്ങളിലും സാൻഡ്ബോക്സിലുമുള്ള എല്ലാ അവകാശങ്ങളും ഉടമസ്ഥാവകാശവും താൽപ്പര്യവും ഞങ്ങളുടെ ഉടമസ്ഥതയിലുള്ളതോ അല്ലെങ്കിൽ ഞങ്ങൾക്ക് ലൈസൻസ് നൽകിയിട്ടുള്ളതോ ആണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകൾക്ക് വിധേയമായി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകൾക്കും കാലാകാലങ്ങളിൽ പുറപ്പെടുവിക്കുന്ന രേഖാമൂലമുള്ള നിർദ്ദേശങ്ങൾക്കും അനുസൃതമായി പ്ലാറ്റ്ഫോം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നിവ ഉപയോഗിക്കാൻ ഞങ്ങൾ നിങ്ങൾക്ക് എക്സ്ക്ലൂസീവല്ലാത്ത</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കൈമാറ്റം ചെയ്യാനാവാത്ത</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സബ് ലൈസൻസ് നൽകാനാവാത്ത</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">റോയൽറ്റിയില്ലാത്ത</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പിൻവലിക്കാവുന്ന</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പരിമിതമായ ലൈസൻസ് നൽകുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 12.0500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l11 level1 lfo16;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്ലാറ്റ്ഫോമുമായോ സേവനങ്ങളുമായോ ബന്ധപ്പെട്ട ബഗ് റിപ്പോർട്ടുകൾ ഉൾപ്പെടെയുള്ള നിർദ്ദേശങ്ങളും മറ്റ് ഫീഡ്ബാക്കും ഇടയ്ക്കിടെ സമർപ്പിക്കാൻ ഞങ്ങൾ നിങ്ങളോട് അഭ്യർത്ഥിച്ചേക്കാം </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഫീഡ്ബാക്ക്</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"). </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അത്തരം ഫീഡ്ബാക്കിന്റെ എല്ലാ അവകാശവും ഉടമസ്ഥാവകാശവും താൽപ്പര്യവും അത്തരം ഫീഡ്ബാക്കിനെ അടിസ്ഥാനമാക്കി എന്തെങ്കിലും വികസനങ്ങൾ സൃഷ്ടിക്കാനുള്ള എക്സ്ക്ലൂസീവായ ഒരു അവകാശവും നിങ്ങൾ ഇതിനാൽ ഞങ്ങൾക്ക് നൽകുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങൾ ഫീഡ്ബാക്ക് സ്വതന്ത്രമായി ഉപയോഗിക്കുകയും പകർത്തുകയും വെളിപ്പെടുത്തുകയും പ്രസിദ്ധീകരിക്കുകയും പ്രദർശിപ്പിക്കുകയും വിതരണം ചെയ്യുകയും ചൂഷണം ചെയ്യുകയും ചെയ്തേക്കാം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l11 level1 lfo16;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകളിൽ പറഞ്ഞിരിക്കുന്നത് ഒഴികെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകളിലുള്ള ഒന്നും ഞങ്ങളുടെയോ ഏതെങ്ക മൂന്നാം കക്ഷിയുടെയോ ബൗദ്ധിക സ്വത്തവകാശങ്ങളിൽ ഏതെങ്കിലും അവകാശമോ ലൈസൻസോ നൽകുന്നതായി വ്യാഖ്യാനിക്കപ്പെടരുത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        9.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കാലാവധിയും അവസാനിപ്പിക്കലും</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l10 level1 lfo17;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">താഴെ കൊടുത്തിരിക്കുന്ന നിബന്ധനകൾക്ക് അനുസൃതമായി അവസാനിപ്പിക്കാത്ത പക്ഷം ഈ നിബന്ധനകൾ പ്രാബല്യത്തിൽ തുടരും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 12.0500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l10 level1 lfo17;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകൾക്ക് കീഴിലുള്ള ഏതെങ്കിലും ബാധ്യതകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഉത്തരവാദിത്തങ്ങൾ അല്ലെങ്കിൽ ഉടമ്പടികൾ നിങ്ങൾ ലംഘിച്ചാൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ ഞങ്ങളുടെ സേവനങ്ങളുടെയോ സാൻഡ്ബോക്സിന്റെയോ ഉപയോക്താവ് ആയിരിക്കുന്നത് അവസാനിക്കുമ്പോൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങളിലേക്കോ സാൻഡ്ബോക്സിലേക്കോ അതിന്റെ ഏതെങ്കിലും ഭാഗത്തേക്കോ ഉള്ള നിങ്ങളുടെ ആക്സസ് അല്ലെങ്കിൽ അതിന്റെ ഉപയോഗം ഞങ്ങളുടെ പൂർണമായ വിവേചനാധികാര പ്രകാരം ഏതു സമയത്തും ഞങ്ങൾ അവസാനിപ്പിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l10 level1 lfo17;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകൾ അവസാനിപ്പിച്ചു കഴിഞ്ഞാൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l21 level1 lfo18;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്രൊഫൈൽ കാലഹരണപ്പെടും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l21 level1 lfo18;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങളുടെ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കാലാവധി തീരും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"; </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കൂടാതെ</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 12.7500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l21 level1 lfo18;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകൾ അവസാനിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അവസാനിപ്പിക്കലിനെയോ കാലഹരണപ്പെടലിനെയോ അതിജീവിക്കുമെന്ന് വ്യക്തമാക്കിയിട്ടുള്ള അല്ലെങ്കിൽ ഉദ്ദേശിച്ചിട്ടുള്ള വ്യവസ്ഥകൾ ഒഴികെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 13.0000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        10.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ബാധ്യതാ നിരാകരണങ്ങളും വാറന്റികളും</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങളിലൂടെയോ സാൻഡ്ബോക്സിലൂടെയോ ലഭ്യമാക്കുന്ന ഏതെങ്കിലും സാമ്പത്തിക വിവരങ്ങളുടെ കൃത്യത</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അനുയോജ്യത അല്ലെങ്കിൽ പിഴവില്ലായ്മ ഞങ്ങൾ ഉറപ്പുനൽകുന്നില്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 12.0500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്ലാറ്റ്ഫോമും സേവനങ്ങൾ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AMD-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">യും സാൻഡ്ബോക്സും ഞങ്ങൾ നൽകുന്നത് അവ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എങ്ങനെയായിരിക്കുന്നുവോ അങ്ങനെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്ന അടിസ്ഥാനത്തിലാണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ടൈറ്റിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, MOM-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ലംഘനം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വ്യാപാരക്ഷമത അല്ലെങ്കിൽ ഒരു പ്രത്യേക ഉദ്ദേശ്യത്തിനായുള്ള അനുയോജ്യത എന്നിവയുടെ പരോക്ഷ വാറന്റികൾ ഉൾപ്പെടെ ഏതെങ്കിലും തരത്തിലുള്ള വ്യക്തമായ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പരോക്ഷമായ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിയമപരമായ അല്ലെങ്കിൽ മറ്റേതെങ്കിലും തരത്തിലുള്ള വാറന്റികളില്ലാതെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങളോ സാൻഡ്ബോക്സോ നിങ്ങളുടെ അപേക്ഷകൾക്ക് ഒപ്പമോ നിങ്ങൾ നൽകുന്ന മറ്റേതെങ്കിലും ഹാർഡ്വെയർ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സോഫ്റ്റ്വെയർ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സിസ്റ്റങ്ങൾ അല്ലെങ്കിൽ ഡാറ്റ എന്നിവയ്ക്ക് ഒപ്പമോ സംയോജിച്ച് പ്രവർത്തിക്കുമെന്ന് ഞങ്ങൾ ഉറപ്പു നൽകുന്നില്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇന്റർനെറ്റ് ഉൾപ്പെടെയുള്ള ആശയവിനിമയ സൗകര്യങ്ങളിലൂടെയുള്ള ഡാറ്റ കൈമാറ്റം ഞങ്ങൾ നിയന്ത്രിക്കുന്നില്ലെന്നും അത്തരം ആശയവിനിമയ സൗകര്യങ്ങളുടെ ഉപയോഗത്തിൽ അന്തർലീനമായ പരിമിതികൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കാലതാമസങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മറ്റ് പ്രശ്നങ്ങൾ എന്നിവയ്ക്ക് സേവനങ്ങൾ വിധേയമായേക്കാമെന്നും നിങ്ങൾ സമ്മതിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മേൽപ്പറഞ്ഞവയിൽ പരിമിതപ്പെടാതെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങൾ ഇനിപ്പറയുന്ന ഒരു വാറന്റിയും നൽകുന്നില്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 10.3500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l22 level1 lfo20;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്ലാറ്റ്ഫോമിലോ സേവനങ്ങളിലോ സാൻഡ്ബോക്സിലോ അടങ്ങിയിരിക്കുന്ന പ്രവർത്തനങ്ങൾ നിങ്ങളുടെ ആവശ്യങ്ങളോ പ്രതീക്ഷകളോ നിറവേറ്റും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ സേവനങ്ങളോ സാൻഡ്ബോക്സോ ഉപയോഗിക്കുന്നത് തടസ്സരഹിതവും സമയബന്ധിതവും സുരക്ഷിതവും പിശകുകളില്ലാത്തതും ആയിരിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l22 level1 lfo20;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്ലാറ്റ്ഫോമിലെ ഏതു പിശകുകളും അല്ലെങ്കിൽ തകരാറുകളും തിരുത്തും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങളിൽ നിന്ന് നിങ്ങൾക്ക് ലഭിക്കുന്ന വാമൊഴിയായോ രേഖാമൂലമോ ഉള്ള ഒരു ഉപദേശമോ വിവരമോ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിബന്ധനകളിൽ വ്യക്തമായി പ്രസ്താവിച്ചിട്ടില്ലാത്ത ഒരു വാറന്റിയും സൃഷ്ടിക്കുന്നതല്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾ സേവനങ്ങളും സാൻഡ്ബോക്സും ഉപയോഗിക്കുന്നതിലൂടെ ഉണ്ടായേക്കാവുന്ന ഏതൊരു അനന്തരഫലങ്ങളുടെയും പൂർണ്ണ ഉത്തരവാദിത്തം നിങ്ങൾ ഇതിനാൽ സ്വീകരിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇക്കാര്യത്തിൽ ഞങ്ങൾക്ക് യാതൊരു ബാധ്യതയുമില്ലെന്ന് നിങ്ങൾ വ്യക്തമായി സമ്മതിക്കുകയും അംഗീകരിക്കുകയും ചെയ്യുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;line-height:140%;
mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സാമ്പത്തിക വിവരദാതാവിൽ നിന്ന് തേടുന്ന ചില സാമ്പത്തിക വിവരങ്ങൾ പ്രോസസ്സിംഗ് ഘട്ടത്തിലായിരിക്കാം അല്ലെങ്കിൽ തത്സമയ വിവരങ്ങൾ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഡീമാറ്റ് ഫോളിയോകൾ പോലെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഉണ്ടായിരിക്കില്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ആയതിനാൽ ഉചിതമായി പ്രതിഫലിച്ചേക്കില്ല എന്ന് നിങ്ങൾ ഇതിനാൽ മനസ്സിലാക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇതിനെ ഞങ്ങളുടെ സേവനങ്ങളിലെ പോരായ്മയായി കണക്കാക്കരുത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങൾ നൽകുന്ന വിവരങ്ങളെ അതനുസരിച്ചു വേണം ആശ്രയിക്കാൻ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 10.8500pt ;line-height:140%;
mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിയമം അനുവദിക്കുന്ന പരമാവധി പരിധി വരെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇനിപ്പറയുന്ന കാരണങ്ങളാൽ ഉണ്ടാകുന്ന ഏതെങ്കിലും നഷ്ടത്തിനോ നാശനഷ്ടത്തിനോ ഞങ്ങളും ഞങ്ങളുടെ അനുബന്ധ സ്ഥാപനങ്ങളും ബന്ധപ്പെട്ട കക്ഷികളും ഓരോരുത്തരും നിങ്ങളോടുള്ള എല്ലാ ബാധ്യതയും നിരാകരിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;line-height:140%;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(i) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങളുടെ ഭാഗത്തെ നിരസിക്കൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്രവർത്തനരഹിതമായ സമയം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">തകരാറ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">തട്ടിപ്പ് അല്ലെങ്കിൽ അശ്രദ്ധ എന്നിവ ഉൾപ്പെടെ സേവനങ്ങളുടെയോ സാൻഡ്ബോക്സിന്റെയോ നിങ്ങളുടെ ഭാഗത്തെ ഉപയോഗം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഉപയോഗിക്കാനുള്ള കഴിവില്ലായ്മ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ലഭ്യത അല്ലെങ്കിൽ ലഭ്യതയില്ലായ്മ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;line-height:140%;
mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങളിലേക്കോ സേവനങ്ങളിൽ നിന്നോ സേവനങ്ങളിലൂടെയോ വിവരങ്ങൾ കൈമാറുന്നതിൽ അല്ലെങ്കിൽ അവയുടെ പ്രവർത്തനത്തിൽ ഉള്ള പോരായ്മ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">തടസ്സം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കാലതാമസങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">തടസ്സങ്ങൾ അല്ലെങ്കിൽ കാലതാമസം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ആശയവിനിമയ പരാജയം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മോഷണം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നാശം അല്ലെങ്കിൽ ഞങ്ങളുടെ രേഖകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്രോഗ്രാമുകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സെർവർ അല്ലെങ്കിൽ സേവനങ്ങളുമായി ബന്ധപ്പെട്ട മറ്റ് അടിസ്ഥാന സൗകര്യങ്ങൾ എന്നിവയിലേക്കുള്ള അനധികൃത ആക്സസ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 12.7500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങളോ സാൻഡ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Noto Sans Malayalam">&#8204;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ബോക്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Noto Sans Malayalam">&#8204;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സോ ഒരു നിശ്ചിത സമയത്തേക്ക് പ്രവർത്തനക്ഷമമായി തുടരുന്നതിൽ പരാജയപ്പെടുന്നത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 12.5000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iv)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഏതെങ്കിലും മുൻകൂട്ടിക്കാണാനാകാത്ത സംഭവങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 11.3000pt ;line-height:140%;
mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (v)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഷെഡ്യൂൾ ചെയ്ത പ്രവർത്തനരഹിതമായ സമയവും ഷെഡ്യൂൾ ചെയ്യാത്ത പ്രവർത്തനരഹിതമായ സമയവും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 12.7500pt ;line-height:140%;
mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകളെ ബാധിച്ചേക്കാവുന്ന ബാധകമായ നിയമത്തിലെ മാറ്റം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 13.7000pt ;line-height:140%;
mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഉപഭോക്താവ് സമ്മതം പിൻവലിക്കുന്നത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇപ്പോൾ പറഞ്ഞത് ഒന്നും ഗണ്യമാക്കാതെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകൾ അല്ലെങ്കിൽ സേവനങ്ങൾ മൂലം നേരിട്ടോ അല്ലാതെയോ ഉണ്ടാകുന്ന ഏതെങ്കിലും പരോക്ഷമോ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ആകസ്മികമോ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്രത്യേകമോ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അനന്തരഫലമോ ആയി ഉണ്ടാകുന്ന ഏതെങ്കിലും നാശനഷ്ടങ്ങൾക്ക് അല്ലെങ്കിൽ വരുമാന നഷ്ടത്തിനോ ലാഭനഷ്ടത്തിനോ ഞങ്ങൾക്കോ ഞങ്ങളുടെ ഏതെങ്കിലും അനുബന്ധ സ്ഥാപനങ്ങൾക്കോ ബന്ധപ്പെട്ട കക്ഷികൾക്കോ നിങ്ങളോടോ ഏതെങ്കിലും മൂന്നാം കക്ഷിയോടോ യാതൊരു ബാധ്യതയും ഉണ്ടായിരിക്കുന്നതല്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നടപടിയുടെ രൂപം ഗണ്യമാക്കാതെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നേരിട്ടുള്ള നാശനഷ്ടങ്ങൾക്കുള്ള ഞങ്ങളുടെ ബാധ്യത </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കരാറിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കരാർ ലംഘനത്തിൽ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അശ്രദ്ധ ഉൾപ്പെടെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഉൾപ്പെടെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) 10,000 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">രൂപയിൽ കൂടരുതെന്ന് നിങ്ങൾ സമ്മതിക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇവിടെ നൽകിയിരിക്കുന്ന ഏതെങ്കിലും പരിമിതമായ പരിഹാരത്തിന്റെ അനിവാര്യ ഉദ്ദേശ്യത്തിന്റെ പരാജയം കണക്കിലെടുക്കാതെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മേൽപ്പറഞ്ഞ ബാധ്യതാ പരിമിതികൾ ബാധകമാകും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 12.0500pt ;line-height:140%;
mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (h)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ആക്സസ് ചെയ്യാനാണ് നിങ്ങൾ ഈ പ്ലാറ്റ്ഫോം ഉപയോഗിക്കുന്നതെങ്കിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങളുടെ ഓഫറുകൾ വിലയിരുത്തലിനായി മാത്രമാണ് ഞങ്ങൾ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ലഭ്യമാക്കിയിരിക്കുന്നതെന്ന് നിങ്ങൾ മനസ്സിലാക്കുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഒരു സാഹചര്യത്തിലും ഇത് ഒരു വാണിജ്യ സേവനമായി കണക്കാക്കില്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങളുടെ ഓഫറുകളുടെ സബ്സ്ക്രിപ്ഷൻ ഉപയോഗിക്കാൻ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">/</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്രയോജനപ്പെടുത്താൻ നിങ്ങൾ ആഗ്രഹിക്കുന്നുവെങ്കിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">sup</span>
                <u>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">port@cookie</span>
                </u>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">j</span>
                <u>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">ar.co.in</span>
                </u>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ൽ നിങ്ങൾക്ക് ഞങ്ങളെ ബന്ധപ്പെടാവുന്നതാണ്</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 13.2500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        11.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നഷ്ടോത്തരവാദിത്വം ഏറ്റെടുക്കൽ</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;line-height:140%;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്ലാറ്റ്ഫോമിലേക്കുള്ള നിങ്ങളുടെ ആക്സസ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സേവനങ്ങളുടെ അല്ലെങ്കിൽ സാൻഡ്ബോക്സിന്റെ ഉപയോഗം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകളുടെ ഏതെങ്കിലും പ്രവൃത്തി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഒഴിവാക്കൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വഞ്ചന</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അശ്രദ്ധ അല്ലെങ്കിൽ ലംഘനം അല്ലെങ്കിൽ സേവനങ്ങൾ ആക്സസ് ചെയ്യാൻ നിങ്ങളോ നിങ്ങളുടെ പ്രൊഫൈൽ ഉപയോഗിച്ചേക്കാവുന്ന ഏതെങ്കിലും മൂന്നാം കക്ഷിയോ നടത്തുന്ന ഈ നിബന്ധനകളുടെ ഏതെങ്കിലും ലംഘനം എന്നിവ മൂലം ഉണ്ടാകുന്ന ഏതെങ്കിലും ക്ലെയിം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഡിമാൻഡ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കേസുകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ജുഡീഷ്യൽ നടപടികൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നഷ്ടങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ബാധ്യതകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നാശനഷ്ടങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ചെലവുകൾ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എല്ലാ നാശനഷ്ടങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ബാധ്യതകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സെറ്റിൽമെന്റുകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അഭിഭാഷക ഫീസ് എന്നിവ ഉൾപ്പെടെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നാൽ അവയിൽ മാത്രം പരിമിതപ്പെടുന്നില്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നിവയിൽ നിന്ന് ഞങ്ങളെയും ഞങ്ങളുടെ മാതൃ കമ്പനിയെയും അനുബന്ധ സ്ഥാപനങ്ങളെയും അഫിലിയേറ്റുകളെയും സംയുക്ത സംരംഭങ്ങളെയും അവരുടെ ഓഫീസർമാരെയും ജീവനക്കാരെയും ഡയറക്ടർമാരെയും ഏജന്റുമാരെയും പ്രതിനിധികളെയും നിങ്ങൾ നഷ്ടോത്തരവാദിത്വത്തിൽ നിന്ന് ഒഴിവാക്കുകയും ഞങ്ങളുടെ ഇഷ്ടപ്രകാരം നിങ്ങൾ അതിനെ പ്രതിരോധിക്കുകയും ചെയ്യും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 13.2500pt ;line-height:140%;
mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        12.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അധികാരപരിധിയും ഭരിക്കുന്ന നിയമങ്ങളും തർക്ക പരിഹാരവും</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;line-height:140%;
mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകൾ നിയന്ത്രിക്കുകയും വ്യാഖ്യാനിക്കുകയും നടപ്പിലാക്കുകയും ചെയ്യുന്നത് ഇന്ത്യയിലെ നിയമങ്ങൾക്ക് അനുസൃതമായിട്ടായിരിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ വകുപ്പിലെ മറ്റ് വ്യവസ്ഥകൾക്ക് വിധേയമായി</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകളിൽ നിന്നോ സേവനങ്ങളുടെ ഉപയോഗത്തിൽ നിന്നോ ഉണ്ടാകുന്ന എല്ലാ പ്രശ്നങ്ങളിലും പൂനെയിലെ കോടതികൾക്ക് എക്സ്ക്ലൂസീവായ അധികാരപരിധി ഉണ്ടായിരിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 12.0500pt ;line-height:140%;
mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകളിൽ നിന്ന് ഉണ്ടാകുന്ന ഏതൊരു വിവാദങ്ങളും സംഘർഷങ്ങളും തർക്കങ്ങളും അല്ലെങ്കിൽ വ്യത്യാസങ്ങളും നിലവിൽ പ്രാബല്യത്തിലുള്ള </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">1996-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ലെ ആർബിട്രേഷൻ ആൻഡ് കൺസിലിയേഷൻ ആക്റ്റ് അനുസരിച്ച് പൂനെയിലെ ആർബിട്രേഷൻ വഴി പരിഹരിക്കുന്നതായിരിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അത് പരാമർശനത്തിലൂടെ ഈ ക്ലോസിൽ ഉൾപ്പെടുത്തിയിട്ടുള്ളതായി കണക്കാക്കപ്പെടുന്നു</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മധ്യസ്ഥതയുടെ ഭാഷ ഇംഗ്ലീഷ് ആയിരിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 11.3000pt ;line-height:140%;
mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മധ്യസ്ഥതയിലെ കക്ഷികൾ മധ്യസ്ഥത രഹസ്യമായി സൂക്ഷിക്കേണ്ടതും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിയമപ്രകാരം ആവശ്യപ്പെടുന്നില്ലെങ്കിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അറിയേണ്ട ആവശ്യമില്ലെങ്കിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ നിയമ ഉപദേഷ്ടാക്കൾക്കല്ലാതെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മറ്റാർക്കും വെളിപ്പെടുത്താതിരിക്കേണ്ടതുമാണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ആർബിട്രേറ്ററുടെ തീരുമാനം അന്തിമവും ഇതിലെ എല്ലാ കക്ഷികളെയും ബാധകവുമായിരിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;line-height:140%;
mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഏതൊരു തർക്കവുമായി ബന്ധപ്പെട്ട് ആർബിട്രേഷനിലെ ഓരോ കക്ഷിയും അവരവരുടെ സ്വന്തം ചെലവുകൾ വഹിക്കേണ്ടതാണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഒരു ഓൺലൈൻ തർക്ക പരിഹാര സംവിധാനമായ </span>
                <u>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">OPR-</span>
                </u>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ലൂടെയും നിങ്ങൾക്ക് ഒരു തർക്കം ഉന്നയിക്കാവുന്നതാണ്</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 13.0000pt ;line-height:140%;
mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        13.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പരാതി പരിഹാരം</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;line-height:140%;
mso-list:l8 level1 lfo23;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾക്ക് എന്തെങ്കിലും പരാതി ഉന്നയിക്കണമെങ്കിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വെബ്സൈറ്റിലെ പരാതി ഓപ്ഷൻ പരിശോധിക്കുക</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l8 level1 lfo23;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഏതു സാഹചര്യത്തിലും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പരാതി ലഭിച്ച തീയതി മുതൽ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">30 (</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">മുപ്പത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ദിവസത്തിനുള്ളിൽ നിങ്ങളുടെ പരാതി പരിഹരിക്കപ്പെടുന്നുണ്ടെന്ന് ഞങ്ങൾ ഉറപ്പാക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
line-height:140%;mso-list:l8 level1 lfo23;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ആ കാലയളവിനുള്ളിൽ പരാതി പരിഹരിക്കപ്പെട്ടില്ലെങ്കിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">താഴെപ്പറയുന്ന വിലാസങ്ങളിൽ നിങ്ങൾക്ക് </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">RBI-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">യിൽ അപ്പീൽ നൽകാവുന്നതാണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <div align=center>
                <table class=MsoNormalTable border=0 cellspacing=0 style="border-collapse:collapse;mso-table-layout-alt:fixed;border:none;
mso-padding-alt:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;">
                    <tr style="height:16.3000pt;">
                        <td width=466 valign=center colspan=2 style="width:279.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 align=center style="margin-bottom:0.0000pt;text-align:center;line-height:140%;">
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">മുംബൈ </span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">(</span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">റീജിയണൽ ഓഫീസ്</span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">)</span>
                                <span style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.5500pt;">
                        <td width=67 valign=center style="width:40.2500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;line-height:140%;">
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">അധികാരപരിധി</span>
                                <span style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=399 valign=center style="width:239.6000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;line-height:140%;">
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">മഹാരാഷ്ട്ര സംസ്ഥാനവും ഗോവ സംസ്ഥാനവും</span>
                                <span style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:15.8500pt;">
                        <td width=67 valign=center style="width:40.2500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;line-height:140%;">
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">വിലാസം</span>
                                <span style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=399 valign=center style="width:239.6000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;line-height:140%;">
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">മൂന്നാം നില</span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, RBI </span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ബിൽഡിംഗ്</span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">എതിർവശം</span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">. </span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">മുംബൈ സെൻട്രൽ റെയിൽവേ സ്റ്റേഷൻ</span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">മറാത്ത മന്ദിറിന് സമീപം</span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ബൈക്കുള</span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">മുംബൈ </span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">- 400 008</span>
                                <span style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.1000pt;">
                        <td width=67 valign=center style="width:40.2500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;line-height:140%;">
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ടെലിഫോൺ</span>
                                <span style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=399 valign=center style="width:239.6000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;line-height:140%;">
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">022-2308 4121/2302 8436</span>
                                <span style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.3000pt;">
                        <td width=67 valign=center style="width:40.2500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;line-height:140%;">
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ഫാക്സ്</span>
                                <span style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=399 valign=center style="width:239.6000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;line-height:140%;">
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">022 2302 2011</span>
                                <span style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.5500pt;">
                        <td width=67 valign=center style="width:40.2500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                            <p class=22 style="margin-bottom:0.0000pt;line-height:140%;">
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ഇ</span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">-</span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">മെയിൽ</span>
                                <span style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=399 valign=center style="width:239.6000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                            <p class=22 style="margin-bottom:0.0000pt;line-height:140%;">
                                <span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;">
                                    <a href="mailto:dnbsmro@rbi.or">dnbsmro@rbi.or</a>
                                </span>
                                <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(51,94,232);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">g</span>
                                <u>
                                    <span class="18" style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(51,94,232);
font-weight:normal;text-decoration:underline;text-underline:single;
font-style:normal;font-variant:normal;font-size:12.75pt;">.in</span>
                                </u>
                                <span style="font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                </table>
            </div>
            <p class=MsoNormal style="line-height:140%;">
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:'Courier New';
color:rgb(0,0,0);font-size:12.0000pt;">
                    <o:p>&nbsp;</o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 13.0000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        14.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പലവക വ്യവസ്ഥകൾ</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;line-height:140%;
mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">പരിഷ്</span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                        <font face="Noto Sans Malayalam">&#8204;</font>
                    </span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ക്കരണം</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എപ്പോൾ വേണമെങ്കിലും ഈ നിബന്ധനകൾ പരിഷ്കരിക്കാനും സേവനങ്ങളുടെ ഉപയോഗത്തിൽ പുതിയതോ കൂടുതലോ ആയ നിബന്ധനകളോ വ്യവസ്ഥകളോ ചേർക്കാനുമുള്ള അവകാശം ഞങ്ങളിൽ നിക്ഷിപ്തമാണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അത്തരം പരിഷ്കാരങ്ങളും കൂടുതലായ നിബന്ധനകളും വ്യവസ്ഥകളും നിങ്ങളെ അറിയിക്കുന്നതാണ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">വ്യക്തമായി നിരസിക്കപ്പെടാത്ത പക്ഷം </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അപ്പോൾ ഈ നിബന്ധനകൾ അവസാനിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">), </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അവ ഉടനടി പ്രാബല്യത്തിൽ വരികയും ഈ നിബന്ധനകളിൽ ഉൾപ്പെടുത്തുകയും ചെയ്യും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അത്തരം മാറ്റങ്ങൾ അംഗീകരിക്കാൻ നിങ്ങൾ വിസമ്മതിക്കുന്ന പക്ഷം ഈ നിബന്ധനകൾ അവസാനിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;line-height:140%;
mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">സെർവബിലിറ്റി</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകളിലെ ഏതെങ്കിലും വ്യവസ്ഥ നിയമവിരുദ്ധമോ നടപ്പിലാക്കാൻ കഴിയാത്തതോ ആണെന്ന് ഏതെങ്കിലും കോടതിയോ മറ്റ് യോഗ്യതയുള്ള അധികാരിയോ നിർണ്ണയിക്കുന്ന പക്ഷം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകളിലെ മറ്റ് വ്യവസ്ഥകൾക്ക് തുടർന്നും പ്രാബല്യമുണ്ടായിരിക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിയമവിരുദ്ധമോ നടപ്പിലാക്കാൻ കഴിയാത്തതോ ആയ ഏതെങ്കിലും വ്യവസ്ഥയുടെ ഒരു ഭാഗം ഇല്ലാതാക്കിയാൽ അത് നിയമപരമോ നടപ്പിലാക്കാൻ കഴിയുന്നതോ ആണെങ്കിൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ആ ഭാഗം ഇല്ലാതാക്കിയതായി കണക്കാക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ശേഷിക്കുന്ന വ്യവസ്ഥ പ്രാബല്യത്തിൽ തുടരും </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അത് പ്രസ്തുത വകുപ്പിന്റെ വ്യക്തമായ ഉദ്ദേശ്യത്തിനു വിരുദ്ധമാകാത്ത പക്ഷം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ സാഹചര്യത്തിൽ പ്രസക്തമായ വ്യവസ്ഥയുടെ മുഴുവൻ ഭാഗവും ഇല്ലാതാക്കിയതായി കണക്കാക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">).</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിയമനം</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങളുടെ രേഖാമൂലമുള്ള മുൻകൂർ അനുമതിയില്ലാതെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകൾക്ക് കീഴിലുള്ള അവരുടെ അവകാശങ്ങൾക്കോ കടമകൾക്കോ ഉടമ്പടികൾക്കോ നിങ്ങൾ ഏതെങ്കിലും തരത്തിൽ ലൈസൻസ് നൽകുകയോ അവ വിൽക്കുകയോ കൈമാറ്റം ചെയ്യുകയോ നിയമിക്കുകയോ ചെയ്യരുത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങളുടെ മാത്രം വിവേചനാധികാരത്തിലും ഉചിതമെന്ന് ഞങ്ങൾ കരുതുന്ന ഏതു വ്യവസ്ഥകൾക്കു വിധേയമായും ഞങ്ങൾ ഈ സമ്മതം നൽകുകയോ തടഞ്ഞുവയ്ക്കുകയോ ചെയ്തേക്കാം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിങ്ങൾക്ക് മുൻകൂർ അറിയിപ്പ് നൽകാതെ തന്നെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഞങ്ങളുടെ ഏതെങ്കിലും അഫിലിയേറ്റുകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അനുബന്ധ സ്ഥാപനങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ മാതൃ കമ്പനികൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">അല്ലെങ്കിൽ സേവനങ്ങളുമായി ബന്ധപ്പെട്ട ഏതെങ്കിലും ബിസിനസ്സിൽ താൽപ്പര്യമുള്ള ഏതെങ്കിലും പിൻഗാമി എന്നിവർക്ക് ഞങ്ങളുടെ അവകാശങ്ങൾ ഞങ്ങൾ നിയമിച്ചു നൽകിയേക്കാം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 11.8000pt ;line-height:140%;
mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">അറിയിപ്പുകള്</span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                        <font face="Noto Sans Malayalam">&#8205;</font>
                    </span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകൾക്ക് കീഴിലുള്ള എല്ലാ അറിയിപ്പുകളും അഭ്യർത്ഥനകളും ഡിമാൻഡുകളും തീരുമാനങ്ങളും </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്രവർത്തന സംബന്ധമായ പതിവ് ആശയവിനിമയങ്ങൾ ഒഴികെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span>
                    <a href="mailto:info@cookiejar.co.in">
                        <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">info@cookiejar.co.in</span>
                    </a>
                </span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">-</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">ലേക്ക് അയയ്ക്കും</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:2.0000pt;tab-stops:left blank 11.3000pt ;line-height:140%;
mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">മൂന്നാം കക്ഷി അവകാശങ്ങൾ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇവിടെ അടക്കം ചെയ്തിരിക്കുന്ന ഏതെങ്കിലും നിബന്ധനകൾ നടപ്പിലാക്കാൻ ഒരു മൂന്നാം കക്ഷിക്കും അവകാശമുണ്ടായിരിക്കുന്നതല്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:2.0000pt;tab-stops:left blank 11.1000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:140%;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">മുൻകൂട്ടിക്കാണാനാകാത്ത സംഭവങ്ങൾ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പണിമുടക്കുകൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഒരു യൂട്ടിലിറ്റി സേവനത്തിന്റെയോ ടെലികമ്മ്യൂണിക്കേഷൻ ശൃംഖലയുടെയോ പരാജയം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">പ്രകൃതി വിപത്ത്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">യുദ്ധം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കലാപം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ആഭ്യന്തര കലാപം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കുത്സിതമായ നാശനഷ്ടങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഏതെങ്കിലും നിയമം അല്ലെങ്കിൽ സർക്കാർ ഉത്തരവ്</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">നിയമം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ചട്ടം അല്ലെങ്കിൽ നിർദ്ദേശം പാലിക്കൽ എന്നിവ ഉൾപ്പെടെ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">എന്നാൽ അവയിൽ പരിമിതപ്പെടാത്ത</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">കാര്യങ്ങൾ പോലെ ഞങ്ങളുടെ ന്യായമായ നിയന്ത്രണത്തിന് അപ്പുറമുള്ള പ്രവൃത്തികൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">സംഭവങ്ങൾ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഒഴിവാക്കലുകൾ അല്ലെങ്കിൽ അപകടങ്ങൾ ഞങ്ങളുടെ ബാധ്യതകൾ നിറവേറ്റുന്നതിൽ നിന്നോ ബിസിനസ്സ് തുടരുന്നതിൽ നിന്നോ ഞങ്ങളെ തടയുകയോ അതു വൈകിപ്പിക്കുകയോ ചെയ്താൽ അക്കാര്യത്തിൽ ഞങ്ങൾക്ക് നിങ്ങളോട് ഒരു ബാധ്യതയും ഉണ്ടായിരിക്കുന്നതല്ല</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. ("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">മുൻകൂട്ടിക്കാണാനാകാത്ത സംഭവങ്ങൾ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">")</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="tab-stops:left blank 11.8000pt ;line-height:140%;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">വിവർത്തനങ്ങൾ</span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകൾ കൂടുതൽ വിശദമായി മനസ്സിലാക്കാൻ നിങ്ങളെ സഹായിക്കാനായി മാത്രം ഈ നിബന്ധനകളുടെ വിവർത്തനം ചെയ്ത പതിപ്പുകൾ ഞങ്ങൾ നിങ്ങൾക്ക് നൽകിയേക്കാം</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഈ നിബന്ധനകളുടെ ഇംഗ്ലീഷ് പതിപ്പും വിവർത്തനം ചെയ്ത പതിപ്പും തമ്മിൽ എന്തെങ്കിലും പൊരുത്തക്കേട് ഉണ്ടായാൽ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ഇംഗ്ലീഷ് പതിപ്പിലെ നിബന്ധനകൾ നിലനിൽക്കും</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Noto Sans Malayalam';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
        </div>
        <!--EndFragment-->
    </body>
</html>
`,
};
